import PropTypes from "prop-types";
import { useState } from "react";
import { ReactComponent as ChevronRight } from "../../../../assets/img/icon/chevron_right_black_24dp.svg";

const CollapsedBox = (props) => {
  const [show, setShow] = useState(props.show || false);
  const handleToggleShow = () => {
    setShow(!show);
  };

  return (
    <div
      className={`relative border border-primary shadow-lg rounded-lg overflow-hidden `}
    >
      <div
        className="bg-secondary text-white px-2 md:px-4 py-1 relative cursor-pointer"
        onClick={handleToggleShow}
      >
        <div className="absolute right-2 top-1 text-white ">
          <ChevronRight
            className={
              "fill-current text-white w-6 h-6 transform duration-200 " +
              (show ? "rotate-90" : "")
            }
          />
        </div>
        <div className="font-semibold">{props.title}</div>
      </div>
      <div
        className={
          "overflow-y-hidden transition-all px-2 md:px-4  " +
          (show ? " py-2 h-auto" : "h-0")
        }
      >
        {props.children}
      </div>
    </div>
  );
};

CollapsedBox.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  show: PropTypes.bool,
};

export default CollapsedBox;
